import { useState } from 'react'
import mixpanel from 'mixpanel-browser'

import { DiscoveryDialog } from 'src/components/Dialogs/DiscoveryAssets/DiscoveryDialog'
import { AppBar, Link, Typography } from '@mui/material'
import { CDN_PATH } from 'src/constants/global'
import styles from './Banner.scss'

interface BannerProps {
  sticky?: boolean
  openEventName?: string
  textColor?: string
  linkColor?: string
  backgroundColor?: string
  unsetStyles?: boolean
}

const Banner = ({
  sticky,
  openEventName,
  textColor,
  linkColor,
  backgroundColor,
  unsetStyles,
}: BannerProps): JSX.Element => {
  const [open, setOpen] = useState(false)
  const handleOpen = (): void => {
    if (openEventName) {
      mixpanel.track(openEventName)
    }
    setOpen(true)
  }
  const handleClose = (): void => setOpen(false)

  return (
    <>
      <AppBar
        className={`${styles.sikaPageBanner as string} ${backgroundColor ? '' : styles.sikaPageBannerWhiteBackground as string}`}
        style={{ backgroundColor }}
        position={sticky ? 'fixed' : 'static'}
        onClick={handleOpen}
        elevation={0}
      >
        <div className={styles.sikaPageBannerContent}>
          <img src={`${CDN_PATH}/images/asset-hsa-thin.svg`} alt="HSA" className={styles.sikaPageBannerIcon} />
          <img src={`${CDN_PATH}/images/asset-fsa-thin.svg`} alt="FSA" className={styles.sikaPageBannerIcon} />
          <Typography
            className={styles.sikaPageBannerText}
            color={textColor ?? 'primary.main'}
            variant={unsetStyles ? 'body3UnsetFont' : 'body3'}
          >
            Have an HSA or FSA? 💰 Put those pre-tax dollars to good use and choose Sika at checkout.
          </Typography>
          <Link
            className={styles.sikaPageBannerLink}
            color={linkColor ?? 'statusBlue.main'}
            variant={unsetStyles ? 'body3UnsetFont' : 'body3'}
          >
            Learn more
          </Link>
        </div>
      </AppBar>
      <DiscoveryDialog isOpen={open} onClose={handleClose} />
    </>
  )
}

export default Banner
